/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  constructor(private httpClient: HttpClient) {}

  async getCategories(): Promise<any> {
    return firstValueFrom(this.httpClient.get(enviroment.url + 'category'));
  }

  async getAntiques(): Promise<any> {
    return firstValueFrom(this.httpClient.get(enviroment.url + 'antiquity'));
  }

  async getPlans(): Promise<any> {
    return firstValueFrom(this.httpClient.get(enviroment.url + 'plan'));
  }

  async getBeneficiaryTypes(): Promise<any> {
    return firstValueFrom(
      this.httpClient.get(enviroment.url + 'tipobeneficiario'),
    );
  }

  async getFaqs(): Promise<any> {
    return firstValueFrom(this.httpClient.get(enviroment.url + 'faq'));
  }

  async getBenefitByCategories(): Promise<any> {
    return firstValueFrom(
      this.httpClient.get(enviroment.url + 'faq'),
    );
  }
}
